module.exports = __webpack_public_path__ + "media/assets/images/blog/matrioshka-small-87c42ed464c8fecdccfd400d84f3cc91.jpg";